<template>
  <div class="previewContainer">
    <p class="previewContainer__title">
      {{ title }}
    </p>
    <div class="previewContainer__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewContainer',
  props: {
    title: {
      type: String,
      required: true,
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';
.previewContainer {
  $root: #{&};
  border: 3px solid #3A3B3F;
  border-radius: 4px;
  &__title {
    padding: 13px 21px;
    background-color: #3A3B3F;
    color: #FFF;
    font-weight: bold;
    font-size: 12px;
    line-height: 1;
  }
  &__content {
    max-height: 670px;
    overflow-y: auto;
  }
}
</style>
